import * as Enums from '../libs/enums';
const {MessageDirection, ScreensEnum} = Enums;

export default {
    data: function () {
        return {
            sharedStore: this.$appStore,
            ScreensEnum: ScreensEnum,
            MessageDirection: MessageDirection
        }
    },
    computed: {
        activeScreen: function () {
            return this.$appStore.state.activeScreen;
        }
    },
    methods: {
        nextScreen: function (screen) {
            this.$appStore.mutations.nextScreen(screen);
        }
    }

}